export var customerReviewsIntroData = {
    title: "Don’t just take our word for it",
    body: {
        type: "doc",
        content: [
            {
                type: "paragraph",
                content: [
                    {
                        text: "We’ve made real people really happy, and are proud to have sold cars to more than 100,000 customers online.",
                        type: "text"
                    }, 
                ]
            },
            {
                type: "paragraph",
                content: [
                    {
                        type: "hard_break"
                    },
                    {
                        text: "With quality cars and service to match, it’s no wonder we’re rated “Excellent” on Trustpilot. Don’t just take our word for it, check out some recent reviews below and join the nation in cinching it.",
                        type: "text"
                    }, 
                ]
            }, 
        ]
    }
};
export var howCinchWorksCustomerReviewsData = {
    title: "How cinch works",
    image: {
        href: "/customer-reviews/customer-reviews-how-cinch-works.jpg",
        alt: "How cinch works"
    },
    body: {
        type: "doc",
        content: [
            {
                type: "paragraph",
                content: [
                    {
                        text: "On our website and app you can browse thousands of cars for sale - using filters to nail your search and find the perfect match. If you’re not sure about the model of car you want, just use our nifty ",
                        type: "text"
                    },
                    {
                        text: "Help Me Choose tool",
                        type: "text",
                        marks: [
                            {
                                type: "link",
                                attrs: {
                                    href: "https://www.cinch.co.uk/which-car-should-i-buy",
                                    uuid: null,
                                    anchor: null,
                                    target: "_self",
                                    linktype: "url"
                                }
                            }, 
                        ]
                    },
                    {
                        text: ". ",
                        type: "text"
                    },
                    {
                        type: "hard_break"
                    },
                    {
                        type: "hard_break"
                    },
                    {
                        text: "When you find the perfect ride, you can buy the car outright or ",
                        type: "text"
                    },
                    {
                        text: "on finance",
                        type: "text",
                        marks: [
                            {
                                type: "link",
                                attrs: {
                                    href: "https://www.cinch.co.uk/car-finance",
                                    uuid: null,
                                    anchor: null,
                                    target: "_self",
                                    linktype: "url"
                                }
                            }, 
                        ]
                    },
                    {
                        text: ". You can even ",
                        type: "text"
                    },
                    {
                        text: "part-exchange",
                        type: "text",
                        marks: [
                            {
                                type: "link",
                                attrs: {
                                    href: "https://www.cinch.co.uk/part-exchange",
                                    uuid: null,
                                    anchor: null,
                                    target: "_self",
                                    linktype: "url"
                                }
                            }, 
                        ]
                    },
                    {
                        text: " your old one at the same time.",
                        type: "text"
                    },
                    {
                        type: "hard_break"
                    },
                    {
                        type: "hard_break"
                    },
                    {
                        text: "Choose to get your car ",
                        type: "text"
                    },
                    {
                        text: "delivered to your home",
                        type: "text",
                        marks: [
                            {
                                type: "link",
                                attrs: {
                                    href: "https://www.cinch.co.uk/delivery",
                                    uuid: null,
                                    anchor: null,
                                    target: "_self",
                                    linktype: "url"
                                }
                            }, 
                        ]
                    },
                    {
                        text: " for free or to a local collection point, and if you don’t absolutely love it within 14 days, ",
                        type: "text"
                    },
                    {
                        text: "we’ll collect it for free",
                        type: "text",
                        marks: [
                            {
                                type: "link",
                                attrs: {
                                    href: "https://www.cinch.co.uk/returns",
                                    uuid: null,
                                    anchor: null,
                                    target: "_self",
                                    linktype: "url"
                                }
                            }, 
                        ]
                    },
                    {
                        text: ", no questions asked. Any payment will be returned in full.",
                        type: "text"
                    }, 
                ]
            }, 
        ]
    }
};
export var faffFreeMotoringCustomerReviewsData = {
    title: "Faff-free motoring",
    image: {
        href: "/customer-reviews/customer-reviews-faff-free-motoring.jpg",
        alt: "Faff-free motoring"
    },
    body: {
        type: "doc",
        content: [
            {
                type: "paragraph",
                content: [
                    {
                        text: "All our cars come with a minimum 6-month MOT and a ",
                        type: "text"
                    },
                    {
                        text: "free 90-day warranty",
                        type: "text",
                        marks: [
                            {
                                type: "link",
                                attrs: {
                                    href: "https://www.cinch.co.uk/car-care/90-day-warranty",
                                    uuid: null,
                                    anchor: null,
                                    target: "_self",
                                    linktype: "url"
                                }
                            }, 
                        ]
                    },
                    {
                        text: " to cover mechanical and electrical components (outside of normal wear and tear) with breakdown assistance from RAC. ",
                        type: "text"
                    }, 
                ]
            },
            {
                type: "paragraph",
                content: [
                    {
                        type: "hard_break"
                    },
                    {
                        text: "You can choose to add ",
                        type: "text"
                    },
                    {
                        text: "cinchCare",
                        type: "text",
                        marks: [
                            {
                                type: "link",
                                attrs: {
                                    href: "https://www.cinch.co.uk/cinch-care",
                                    uuid: null,
                                    anchor: null,
                                    target: "_self",
                                    linktype: "url"
                                }
                            }, 
                        ]
                    },
                    {
                        text: ", our monthly maintenance plan including Lifetime Warranty and Servicing, as well as ",
                        type: "text"
                    },
                    {
                        text: "cinchShield",
                        type: "text",
                        marks: [
                            {
                                type: "link",
                                attrs: {
                                    href: "https://www.cinch.co.uk/car-care/cinch-shield",
                                    uuid: null,
                                    anchor: null,
                                    target: "_self",
                                    linktype: "url"
                                }
                            }, 
                        ]
                    },
                    {
                        text: " to ensure your car’s bodywork stays in tip-top condition. ",
                        type: "text"
                    }, 
                ]
            },
            {
                type: "paragraph",
                content: [
                    {
                        type: "hard_break"
                    },
                    {
                        text: "If you’re going electric, you’ll get a ",
                        type: "text"
                    },
                    {
                        text: "cinchCharge",
                        type: "text",
                        marks: [
                            {
                                type: "link",
                                attrs: {
                                    href: "https://www.cinch.co.uk/car-care/charging-electric-cars",
                                    uuid: null,
                                    anchor: null,
                                    target: null,
                                    linktype: "url"
                                }
                            }, 
                        ]
                    },
                    {
                        text: " card when you buy an EV from us. The card and its app makes finding and using public charging a breeze.",
                        type: "text"
                    }, 
                ]
            }, 
        ]
    }
};
